<div class="flex basis-full content-''">
  <h1 class="text-left basis-full content-''">{{this.getWeighingType() }} - {{ "GENERAL.BATCH" | appString }} {{ this.batchWeighingViewModel().batchNumber }} </h1>

  <div [formGroup]="genderGroup" class="text-right justify-end content-center basis-full content-''">
    <mat-form-field class="mx-1">
      <mat-label>{{ "GENERAL.GENDER" | appString }}</mat-label>
      <mat-select class="mat-select-panel" required formControlName="genderSelect">
        @for (gender of this.domainService.GetPigGenders(); track gender) {
          <mat-option class="mat-select-option" [value]="gender.id"  >{{ gender.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button
      class="mx-1"
      [disabled] = "!hasPreviousBatchWeighing()"
      (click)="saveGotoPreviousBatch()">
      {{ "GENERAL.SAVEANDPREVIOUSTEAM" | appString }}
    </button>
    <button
      class="mx-1"
      (click)="save()">
      {{ "GENERAL.SAVE" | appString }}
    </button>
    <button
      class="mx-1"
      [disabled]="!hasNextBatchWeighing()"
      (click)="saveAndNavigateToNextBatch()">
      {{ "GENERAL.SAVEANDNEXTTEAM" | appString }}
    </button>
  </div>
</div>


<div class="mat-elevation-z8 rounded-md">
  <div class="grid items-center grid-cols-11 text-center text-4xl font-bold rounded-t-md bg-segesblue50 py-1">
    <div>{{ "GENERAL.PEN" | appString }}</div>
    <div>{{ "GENERAL.GROUP" | appString }}</div>
    <div>{{ "GENERAL.FEED" | appString }}</div>
    <div></div>
    <div class="col-span-2">{{ "GENERAL.NUMBEROFPIGS" | appString }}</div>
    <div class="col-span-2">{{ "GENERAL.WEIGHTINKG" | appString }}</div>
    <div></div>
    <div class="col-span-2">{{ "GENERAL.AVERAGEWEIGHTPERPEN" | appString }}</div>
  </div>
  @for(weighingId of this.batchWeighingViewModel().animalWeighingIds; track weighingId) {
    <div class="w-full hover:bg-segeslightblue50 odd:bg-white even:bg-gray-100">
      <app-reg-animal-weights
        [animalWeighingId]="weighingId"
        (inputFormChanged)="onInputFormChanged($event)"
        class="w-full">
      </app-reg-animal-weights>
    </div>
  }
  <div class="grid grid-cols-11 text-center bg-segesblue50 rounded-b-md text-3xl font-bold py-1">
    <div class="col-start-5 col-span-2">
      {{ "GENERAL.SUM" | appString }}: {{ this.numberOfAnimalsTotal() }}
    </div>
    <div class="col-start-7 col-span-2">
      {{ "GENERAL.AVERAGEWEIGHTSHORT" | appString }}: {{ this.getAverageWeight() }}
    </div>
  </div>
</div>
